import {
  INCIDENTS_LOAD,
  INCIDENTS_ADD_NEW,
  INCIDENTS_CLEAR,
  INCIDENTS_LOAD_EVENT_TYPES,
  INCIDENTS_CALENDAR_CHANGE_DATE,
  INCIDENTS_CALENDAR_CHANGE_VIEW,
  INCIDENTS_CALENDAR_RESET,
  INCIDENTS_SET_KEYWORD,
  INCIDENTS_UPDATE,
  INCIDENTS_DELETE,
} from '../actionTypes/incidents';

import { ViewsEnum } from '../../pages/Incidents/utils/constants';
import { IIncident } from '../../pages/Incidents/interfaces';

export const loadIncidentsAction = ({
  incidents,
  sorted = false,
}: {
  incidents: any;
  sorted?: boolean;
}) => ({
  type: INCIDENTS_LOAD,
  payload: { incidents, sorted },
});

export const addNewIncidentAction = (newIncident: IIncident) => ({
  type: INCIDENTS_ADD_NEW,
  payload: newIncident,
});

export const updateIncidentAction = (updatedIncident: IIncident) => ({
  type: INCIDENTS_UPDATE,
  payload: updatedIncident,
});

export const deleteIncidentAction = ({
  incidentId,
}: {
  incidentId: string;
}) => ({
  type: INCIDENTS_DELETE,
  payload: { incidentId },
});

export const clearIncidentsAction = () => ({
  type: INCIDENTS_CLEAR,
});

export const loadIncidentTypesAction = (incidentTypes: any[]) => ({
  type: INCIDENTS_LOAD_EVENT_TYPES,
  payload: incidentTypes,
});

export const changeDateAction = (date: any) => ({
  type: INCIDENTS_CALENDAR_CHANGE_DATE,
  payload: date,
});

export const changeViewAction = (view: ViewsEnum) => ({
  type: INCIDENTS_CALENDAR_CHANGE_VIEW,
  payload: view,
});

export const resetCalendarAction = () => ({
  type: INCIDENTS_CALENDAR_RESET,
});

export const setIncidentsKeywordAction = (keyword: string) => ({
  type: INCIDENTS_SET_KEYWORD,
  payload: keyword,
});
